import { render, staticRenderFns } from "./MultipleSingleAutobuyersGroup.vue?vue&type=template&id=59ad48ab&scoped=true"
import script from "./MultipleSingleAutobuyersGroup.vue?vue&type=script&lang=js"
export * from "./MultipleSingleAutobuyersGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad48ab",
  null
  
)

export default component.exports